import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import { getDataApi1, loadApi, saveApi} from "../services/appApi";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const K1s  = () => {

  let emptyRow = {
    CLIENT_K1_ID: null,
    CLIENT_ID: null,
    TAX_YEAR: null,
    PAYER_NAME: null,
    ORDINARY_INCOME: null,
    RENTAL_REAL_ESTATE_INCOME: null,
    OTHER_RENTAL_INCOME: null,
    INTEREST_INCOME: null,
    ORDINARY_DIVIDENTS: null,
    QUALIFIED_DIVIDENTS: null,
    SHORT_TERM_CAPGAIN_LOSS: null,
    LONG_TERM_CAPGAIN_LOSS: null,
    OTHER_INCOME_LOSS: null,
    DESCRIPTION: null,
    ACCOUNT_OWNER_LKCD: null,
    ACCOUNT_OWNER_CODE_MEAN: null,
    ACCOUNT_OWNER_CODE_DESC: null,
    FIRM_ID: null,
    CLIENT_TYPE_LKCD: null,
    CLIENT_TYPE_MEAN: null,
    CLIENT_TYPE_DESC: null,
    BUSINESS_LEGAL_NAME: null,
    BUSINESS_DBA_NAME: null,
    BUSINESS_FEDERAL_TAX_ID: null,
    BUSINESS_PHONE_NUMBER: null,
    BUSINESS_EMAIL_ADDRESS: null,
    CLIENT_FIRST_NAME: null,
    CLIENT_MIDDLE_NAME: null,
    CLIENT_LAST_NAME: null,
    SPOUSE_FIRST_NAME: null,
    SPOUSE_MIDDLE_NAME: null,
    SPOUSE_LAST_NAME: null,
    CLIENT_FEDERAL_TAX_ID: null,
    CLIENT_FEDERAL_TAX_ID_TYPE: null,
    SPOUSE_FEDERAL_TAX_ID: null,
    SPOUSE_FEDERAL_TAX_ID_TYPE: null,
    CLIENT_CONTACT_CELL_PHONE: null,
    CLIENT_CONTACT_WORK_PHONE: null,
    CLIENT_CONTACT_HOME_PHONE: null,
    CLIENT_CONTACT_EMAIL_ADDRESS: null,
    SPOUSE_CONTACT_CELL_PHONE: null,
    SPOUSE_CONTACT_WORK_PHONE: null,
    SPOUSE_CONTACT_HOME_PHONE: null,
    SPOUSE_CONTACT_EMAIL_ADDRESS: null,
    TAX_YEAR_DESCRIPTION: null,
    CREATION_DATE: null,
    LAST_UPDATE_DATE: null,
    CREATED_BY: null,
    LAST_UPDATED_BY: null
    };

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [filters, setFilters] = useState({
      client_first_name: {value: null, matchMode: FilterMatchMode.IN,},
      tax_year: {value: null, matchMode: FilterMatchMode.IN,}
    });
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1(`/ztx_client_k1s_v/?offset=${offset}&limit=${limit}`);
        allData = [...allData, ...response.data.items];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
        }
         if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
            // Set the error message and display the dialog
            setIsLoading(false);
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  const numOrdIncTemplate = (rowData) => {
    return (rowData.ordinary_income || rowData.ordinary_income === 0) ? numeral(rowData.ordinary_income).format('0,0.00') : null;
  };
  const numRentREIncTemplate = (rowData) => {
    return (rowData.rental_real_estate_income || rowData.rental_real_estate_income === 0) ? numeral(rowData.rental_real_estate_income).format('0,0.00') : null;
  };
  const numOtherRentTemplate = (rowData) => {
    return (rowData.other_rental_income || rowData.other_rental_income === 0) ? numeral(rowData.other_rental_income).format('0,0.00') : null;
  };
  const numIntIncomeTemplate = (rowData) => {
    return (rowData.interest_income || rowData.interest_income === 0) ? numeral(rowData.interest_income).format('0,0.00') : null;
  };
  const numOrdDivsTemplate = (rowData) => {
    return (rowData.ordinary_dividents || rowData.ordinary_dividents === 0) ? numeral(rowData.ordinary_dividents).format('0,0.00') : null;
  };
  const numQualDivsTemplate = (rowData) => {
    return (rowData.qualified_dividents || rowData.qualified_dividents === 0) ? numeral(rowData.qualified_dividents).format('0,0.00') : null;
  };
  const numSTCapGainTemplate = (rowData) => {
    return (rowData.short_term_capgain_loss || rowData.short_term_capgain_loss === 0) ? numeral(rowData.short_term_capgain_loss).format('0,0.00') : null;
  };
  const numLTCapGainTemplate = (rowData) => {
    return (rowData.long_term_capgain_loss || rowData.long_term_capgain_loss === 0) ? numeral(rowData.long_term_capgain_loss).format('0,0.00') : null;
  };
  const numOtherIncomeTemplate = (rowData) => {
    return (rowData.other_income_loss || rowData.other_income_loss === 0) ? numeral(rowData.other_income_loss).format('0,0.00') : null;
  };

  const numOrdInc = (row.ordinary_income || row.ordinary_income === 0) ? numeral(row.ordinary_income).format('0,0.00') : null;
  const numRentREInc = (row.rental_real_estate_income || row.rental_real_estate_income === 0) ? numeral(row.rental_real_estate_income).format('0,0.00') : null;
  const numOtherRent = (row.other_rental_income || row.other_rental_income === 0) ? numeral(row.other_rental_income).format('0,0.00') : null;
  const numIntIncome = (row.interest_income || row.interest_income === 0) ? numeral(row.interest_income).format('0,0.00') : null;
  const numOrdDivs = (row.ordinary_dividents || row.ordinary_dividents === 0) ? numeral(row.ordinary_dividents).format('0,0.00') : null;
  const numQualDivs = (row.qualified_dividents || row.qualified_dividents === 0) ? numeral(row.qualified_dividents).format('0,0.00') : null;
  const numSTCapGain = (row.short_term_capgain_loss || row.short_term_capgain_loss === 0) ? numeral(row.short_term_capgain_loss).format('0,0.00') : null;
  const numLTCapGain = (row.long_term_capgain_loss || row.long_term_capgain_loss === 0) ? numeral(row.long_term_capgain_loss).format('0,0.00') : null;
  const numOtherIncome = (row.other_income_loss || row.other_income_loss === 0) ? numeral(row.other_income_loss).format('0,0.00') : null;

  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
}

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">K1s Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      K1s
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };
  
  const clientOptions = [...new Set(rows.map((item) =>  item.client_first_name).filter(Boolean)),].map((client_first_name) => ({
    label: client_first_name, value: client_first_name,
  }));

  const taxYearOptions = [...new Set(rows.map((item) =>  item.tax_year).filter(Boolean)),].map((tax_year) => ({
    label: tax_year, value: tax_year,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={clientOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Client"
    display="chip" showClear/>
  )

  const taxYearFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={taxYearOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Tax Year"
    display="chip" showClear/>
  )

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">K1s</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="client_k1_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={taxPageRows}
          rowsPerPageOptions={taxRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          filters={filters}
          filterDisplay="row"
          onFilter={(e) => setFilters(e.filters)}
        >
         
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="client_first_name" header="Client" sortable filter showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} filterElement={clientFilterTemplate}></Column>
          <Column field="tax_year" header="Tax Year" filter showFilterMenu={false} filterElement={taxYearFilterTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="payer_name" header="Payer" sortable></Column>
          <Column field="ordinary_income" header="OrdInc" body={numOrdIncTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="rental_real_estate_income" header="RentREInc" body={numRentREIncTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="other_rental_income" header="OtherRent" body={numOtherRentTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="interest_income" header="IntIncome" body={numIntIncomeTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="ordinary_dividents" header="OrdDivs" body={numOrdDivsTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="qualified_dividents" header="QualDivs" body={numQualDivsTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="short_term_capgain_loss" header="STCapGain" body={numSTCapGainTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="long_term_capgain_loss" header="LTCapGain" body={numLTCapGainTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="other_income_loss" header="OtherIncome" body={numOtherIncomeTemplate} bodyStyle={{textAlign: "right"}}sortable></Column>
        </DataTable>
      </div>
      )}

      <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="K1s" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="tax_year">Tax Year</label>
                    <div className="box">
                        {row.tax_year}
                    </div>

                <label htmlFor="payer_name">Payer</label>
                    <div className="box">
                        {row.payer_name}
                    </div>

                <label htmlFor="ordinary_income">OrdInc</label>
                    <div className="box">
                        {numOrdInc}
                    </div>
                <label htmlFor="rental_real_estate_income">RentREInc</label>
                    <div className="box">
                        {numRentREInc}
                    </div>

                <label htmlFor="other_rental_income">OtherRent</label>
                    <div className="box">
                        {numOtherRent}
                    </div>

                <label htmlFor="interest_income">IntIncome</label>
                    <div className="box">
                        {numIntIncome}
                    </div>

                <label htmlFor="ordinary_dividents">OrdDivs</label>
                    <div className="box">
                        {numOrdDivs}
                    </div>
                <label htmlFor="qualified_dividents">QualDivs</label>
                    <div className="box">
                        {numQualDivs}
                    </div>

                <label htmlFor="short_term_capgain_loss">STCapGain</label>
                    <div className="box">
                        {numSTCapGain}
                    </div>

                <label htmlFor="long_term_capgain_loss">LTCapGain</label>
                    <div className="box">
                        {numLTCapGain}
                    </div>

                <label htmlFor="other_income_loss">OtherIncome</label>
                    <div className="box">
                        {numOtherIncome}
                    </div>

            </Dialog>
            {!apiErrorDialog && (
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{width: '25rem'}}
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            )}
            </div>
    </div>
  );
};

export default K1s;